const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// POST to an SSE endpoint and invoke callbacks per event. Returns the response headers.
export async function streamPost(path, body, { onDelta, onMeta, onError, onEvent, signal } = {}) {
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    signal,
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body || {}),
  });
  if (!res.ok) {
    let detail = "Request failed";
    try { detail = (await res.json()).detail || detail; } catch {}
    onError?.(typeof detail === "string" ? detail : JSON.stringify(detail));
    return res.headers;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      const line = p.split("\n").find((l) => l.startsWith("data: "));
      if (!line) continue;
      const ev = JSON.parse(line.slice(6));
      onEvent?.(ev);
      if (ev.delta) onDelta?.(ev.delta);
      else if (ev.model) onMeta?.(ev);
      else if (ev.error) onError?.(ev.error);
    }
  }
  return res.headers;
}

export const MODEL_LABEL = {
  "claude-opus-4-8": "Claude Opus 4.8",
  "claude-sonnet-4-6": "Claude Sonnet 4.6",
  "claude-haiku-4-5-20251001": "Claude Haiku 4.5",
  "gpt-5.4": "ChatGPT 5.4",
  "gpt-5.4-mini": "ChatGPT 5.4 Mini",
};

export const PROVIDERS = [
  { id: "auto", label: "Auto" },
  { id: "claude", label: "Claude" },
  { id: "chatgpt", label: "ChatGPT" },
];
